module.exports = __webpack_public_path__ + "vg.1e105cc2f1c103861678.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/vg.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/vg.svg
// module chunks = styles